module.exports = __webpack_public_path__ + "img/consultation2.a289b51c.png";